import React from 'react';

// Import all interactive components
import FormulaBuilderDragDrop from './FormulaBuilderDragDrop';
import DragAndDropMatch from './DragAndDropMatch';
import DistributionSlider from './DistributionSlider'; // ← add this line

const components = {
  FormulaBuilderDragDrop,
  DragAndDropMatch,
  DistributionSlider, // ← register it here
};

export default function InteractiveRenderer({ component, config }) {
  const Comp = components[component];

  if (!Comp) {
    return (
      <div className="text-red-500">
        ⚠️ Interactive component <strong>{component}</strong> not found.
      </div>
    );
  }

  return <Comp config={config} />;
}
